import { Input } from '@arcadiapower/shrike';
import styled from 'styled-components';
import { Text } from '~/components/typography';

export const StyledInput = styled(Input)`
  label {
    font-family: ${props => props.theme.fontFamilies.main.medium};
  }

  ${props =>
    props.readOnly &&
    `
    div {
      background-color: ${props.theme.colors.background.tertiary};
      opacity: ${props.theme.opacities.medium};
    }
    `}
`;

export const Requirements = styled(Text)<{ isValid?: boolean }>`
  margin-top: 8px;

  ${props => {
    if (props.isValid) {
      return `color: ${props.theme.colors.content.accent4};`;
    } else {
      return `opacity: ${props.theme.opacities.medium};`;
    }
  }}
`;
